import { Directive, ElementRef, HostListener, Renderer2, Input } from '@angular/core';

@Directive({
  selector: '[itpxAddClassOnMouseover]'
})
export class AddClassOnMouseover {

  @Input('itpxAddClassOnMouseover') cssClassName: string;
  @Input() targetClass: string;
   
  constructor(private renderer: Renderer2, private el: ElementRef) { }
 
  @HostListener('mouseenter') onMouseEnter() {
    this.renderer.addClass(this.el.nativeElement.closest(this.targetClass), this.cssClassName);
  }
 
  @HostListener('mouseleave') onMouseLeave() {
    this.renderer.removeClass(this.el.nativeElement.closest(this.targetClass), this.cssClassName);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/addClassOnMouseOver.ts